import Pluralize from 'pluralize'

// Categories we don't want pluralized (e.g. "AI" -> "AI", not "AIs"). Handled
// locally instead of via `Pluralize.addUncountableRule` to avoid mutating the
// process-wide pluralize singleton, which would affect every other consumer
// of the library in the bundle.
const UNCOUNTABLE_CATEGORIES = new Set(['AI'])

/**
 * Pluralize an actor category label (e.g. "Bot" -> "Bots") for use in the
 * category filter segmented control and dropdown panel title.
 */
export function pluralizeCategory(name: string): string {
  if (UNCOUNTABLE_CATEGORIES.has(name)) return name
  return Pluralize(name)
}
